import React from 'react';
import  { Container, Row, Col, Card, Form, Button,  Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { TimerAlert, ConfirmAlert } from '../../utils/swtAlert';
import { CreateIndustryType, GetIndustryTypeById, UpdateIndustryType } from '../../utils/axios/LookUpAPI';
import { GrokLoading } from "../page-layout/loading/Loading";
import { Decrypt } from '../../utils/Helper';


function IndustryTypeDetail(props) {
    const navigate = useNavigate();
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [isUpdate, setIsUpdate] = useState();
    const [loading, setLoading] = useState(false);

    //Form Control Variables Starts..
    const [name, setName] = useState("");
    //Form Control Variables Ends..

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            saveIndustryType();
        }
    }

    const saveIndustryType =  async () => {
        var industryTypePayload = {
            Name: name, 
            Type: 3,
        }   
        if (location.state.industrytypeid != null) {
            industryTypePayload.UpdatedBy = userInfo._id;
            var industryTypeResponse = await UpdateIndustryType(industryTypePayload, location.state.industrytypeid);
            if (industryTypeResponse.message) {
                TimerAlert('Industry Vertical Creation Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'Industry Vertical Updated Successfully', 'success');
                setTimeout(() => navigate("/industryverticals"), delay);
            }
        }
        else {
            industryTypePayload.CreatedBy = userInfo._id;
            var industryTypeResponse = await CreateIndustryType(industryTypePayload);
            if(industryTypeResponse.message) {
                TimerAlert('Industry Vertical Creation Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'Industry Vertical Created Successfully', 'success');
                setTimeout(() => navigate("/industryverticals"), delay);
            }
        }
    }

    const bindFormData = async () => {
        if (location.state.industrytypeid !== null) {
            setLoading(true);
            var response = await GetIndustryTypeById(location.state.industrytypeid);
            setLoading(false);
            setName(response.Name);
        }
    }
    const BackBtn = () => {
        navigate('/industryverticals', { state: { industrytypeid: null } });
    }
    const clearState = () => {
        setName("");
    };
    const clear = () => {
        ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
        .then((result) => {
            if (result.isConfirmed) {
                clearState();
            }
        });
    };
    const addRefresh = () => {
        navigate('/home', {state: {industrytypeid: null}});
    }

    const handleIndustry = () => {
        navigate('/industryverticals', {state: {industrytypeid: null}});
    }
    useEffect(() => {
        if(location.state.industrytypeid != null){
            setIsUpdate(true);
        }
        else{
            setIsUpdate(false);
        }
        bindFormData();
        setTimeout(() => {
            document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show'); 
            document.getElementById('nav-dropdownSuperadmin').nextSibling.children[2].classList.add('active');
        }, 300);
    }, [])

    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home </Breadcrumb.Item>
                                    <Breadcrumb.Item onClick={() => handleIndustry()}> Industry Vertical</Breadcrumb.Item>
                                    <Breadcrumb.Item active> Industry Vertical details</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col>
                                {!isUpdate && <h2 className="page-title">Add Industry Vertical</h2>}
                                {isUpdate && <h2 className="page-title">Edit Industry Vertical</h2>}
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        {/* <Card.Title className='fw-bold mb-3'>Add Student Information:</Card.Title> */}

                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                            <Row >
                                                <Col lg={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> <h4>Industry Vertical Details</h4> </Form.Label>
                                                    </Form.Group>
                                                </Col><hr/>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Industry Vertical<em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="Name"  value={name} onChange={(e)=> setName(e.target.value)} minLength={3} placeholder="Enter Industry Vertical" required/>
                                                            <Form.Control.Feedback type="invalid">Please Enter Industry Vertical!</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Row>
                                                    <Col xs={4}>
                                                        <Button variant="danger" type="button" size="sm" aria-label="small button" onClick={() => clear()}> Clear</Button>
                                                    </Col>
                                                    <Col>
                                                        <div className="d-flex gap justify-content-end">
                                                            <Button variant="success" size="sm" aria-label="small button" type="submit"> Save </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>
    )
}
export default IndustryTypeDetail;